/**
 *
 * ClickableUser
 * Opens modal with UserModals when clicked
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import UserText from 'components/media/UserText/Loadable.js';
import { getIdNumber } from 'utils/userIdRole.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import { APPLICATION_ROLE } from 'containers/User/constants.js';
import messages from './messages.js';

function ClickableUser(props) {
  const { user, children, firstNameOnly } = props;
  const role = useCurrentRole();
  function getNameAndHash() {
    if (user === null) {
      return { name: <span className="text-muted me-2"><FormattedMessage {...messages.deletedUser} /></span> };
    }
    if (!user) {
      return {};
    }
    if (typeof user === 'string') {
      return { name: user };
    }
    if (user.id < 0) {
      return { name: <UserText inline className="text-muted me-2">{user.displayName}</UserText> };
    }
    const name = <UserText inline>{(firstNameOnly && role && role.id === user.id && role.firstName) || user.displayName}</UserText>;
    if (user.roleType === APPLICATION_ROLE) {
      return { name };
    }
    if (user.canRead === false) {
      return { name: children || name };
    }
    const userId = getIdNumber({
      userId: user.id,
      roleType: user.roleType,
    });
    const hash = `#user=${userId}`;
    return { name, hash };
  }
  const { hash, name } = getNameAndHash();
  if (!name) {
    return null;
  }
  if (!children) {
    return hash ? <Button variant="link" className="p-0 text-start" href={hash}>{name}</Button> : name;
  }
  return React.Children.map(children, (child) => React.cloneElement(child, { href: hash }));
}

ClickableUser.propTypes = {
  user: PropTypes.object,
  firstNameOnly: PropTypes.bool,
  children: PropTypes.node,
};

export default ClickableUser;
